import { render, staticRenderFns } from "./TestSmsText.vue?vue&type=template&id=7e9a92fa&"
import script from "./TestSmsText.vue?vue&type=script&lang=js&"
export * from "./TestSmsText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports